// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ac1c8dcf","455":"fc62667c"}[chunkId] + ".chunk.js";
};